import { render, staticRenderFns } from "./WriteBook.vue?vue&type=template&id=d1fff650&scoped=true&"
import script from "./WriteBook.vue?vue&type=script&lang=js&"
export * from "./WriteBook.vue?vue&type=script&lang=js&"
import style0 from "./WriteBook.vue?vue&type=style&index=0&id=d1fff650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fff650",
  null
  
)

component.options.__file = "WriteBook.vue"
export default component.exports